module.exports = __webpack_public_path__ + "img/key_features--accessories.b9a419bc.jpg";